import React, { useEffect } from 'react';
import { useBreadcrumbs } from '../BreadcrumbContext';
import { WorkflowChat } from './WorkflowChat';

export default function CreateRulePrompt() {
    const { setBreadcrumbs } = useBreadcrumbs();

    useEffect(() => {
        setBreadcrumbs([
            {
                label: 'AI Console',
                path: '/ai-builder',
            },
        ]);
    }, []);

    return (
        <div className="min-h-0 h-full">
            <div className="space-y-4">
                <div className="text-left space-y-1">
                    <h1 className="text-xl font-semibold text-gray-900">AI Workflow Builder</h1>
                    <p className="text-sm text-muted-foreground">Create workflows with natural language — select phases, answer questions, and choose templates.</p>
                </div>
                <WorkflowChat />
            </div>
        </div>
    );
}